// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a3bfcd73","698":"c088c05c"}[chunkId] + ".chunk.js";
};